import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Chart,
  LineElement,
  Legend,
  LinearScale,
  Tooltip,
  CategoryScale,
  PointElement,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import annotationPlugin from 'chartjs-plugin-annotation';
import intlShape from '@/shared/utils/intlShape';

import { listItemMsg } from '@/shared/components/FormattedListValue';
import { numberTooltipLabel } from '@/shared/utils/chartjsHelpers';
import { useIntl } from 'react-intl';
import messages from './budgetMessages';

Chart.register(
  LineElement,
  Legend,
  LinearScale,
  Tooltip,
  CategoryScale,
  PointElement,
  annotationPlugin,
);

const BigBudgetGraph = ({ data, budget, dataLabel, intl }) => {
  const [chartData, chartOptions] = useMemo(() => {
    if (!data) return [null, null];
    const cData = {
      labels: Array.from({ length: 12 }, (x, i) =>
        intl.formatMessage(
          listItemMsg(
            i + 1,
            'month',
            moment()
              .month(i)
              .format('MMMM'),
          ),
        ),
      ),
      datasets: [
        {
          label: dataLabel,
          data,
          borderColor: '#0060ff',
          type: 'line',
        },
      ],
    };
    const budgetAnnotation = {
      type: 'line',
      yMin: budget,
      yMax: budget,
      label: { content: intl.formatMessage(messages.Budget) },
      borderColor: '#76a6af',
      borderDash: [6, 6],
      borderDashOffset: 0,
      drawTime: 'beforeDatasetsDraw',
    };
    const spreadAnnotation = {
      type: 'line',
      label: { content: intl.formatMessage(messages.BudgetSpreadOverPeriod) },
      borderColor: '#ffaa21',
      drawTime: 'beforeDatasetsDraw',
      yMin: 0,
      yMax: budget,
    };

    const cOptions = {
      scales: {
        x: {
          grid: { display: true },
        },
        y: {
          ticks: {
            beginAtZero: true,
          },
        },
      },

      plugins: {
        annotation: {
          annotations: {
            budgetAnnotation,
            spreadAnnotation,
          },
        },
        tooltip: {
          callbacks: {
            label: numberTooltipLabel,
          },
        },
      },
    };

    return [cData, cOptions];
  }, [data, budget, dataLabel, intl]);

  if (!data) return null;

  return (
    <div className="chart-container">
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};

BigBudgetGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number),
  budget: PropTypes.number,
  dataLabel: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};
BigBudgetGraph.defaultProps = {
  data: [],
  budget: 0,
};
export default BigBudgetGraph;
